import React from 'react';
import { useCopilot } from './CopilotContext';
import { ASTRA_ICON_URL } from './brand';
import './Copilot.scss';

interface CopilotTriggerProps {
  isAuthenticated: boolean;
}

export function CopilotTrigger({ isAuthenticated }: CopilotTriggerProps) {
  const { state, togglePanel } = useCopilot();

  if (!isAuthenticated || state.isOpen) return null;

  // Custom FAB instead of a Cloudscape Button: Button caps iconUrl at 16px, too small for
  // the launcher. Image is decorative (alt=""); accessible name comes from aria-label.
  return (
    <div className="copilot-trigger">
      <button
        type="button"
        className="copilot-trigger-button"
        onClick={togglePanel}
        aria-label="Open Astra"
      >
        <img className="copilot-trigger-icon" src={ASTRA_ICON_URL} alt="" />
      </button>
    </div>
  );
}
